import PropTypes from "prop-types";
import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API";
import { useSignups } from "Signups/state.js";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";
import FnrHoverButton from "UI/FnrHoverButton";
import FnrIcon from "UI/FnrIcon";
import { FnrPopover } from "UI/FnrPopover2";

import { ReminderButtonContent } from "./styles";

ManualReminderButton.propTypes = {
  signupListID: PropTypes.number.isRequired,
};

export default function ManualReminderButton({ signupListID }) {
  const [showSendReminderConfirmation, setShowSendReminderConfirmation] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useSignups();
  const buttonRef = useRef(null);

  const sendManualReminders = (e) => {
    if (e) e.stopPropagation();
    setLoading(true);

    API.sendManualReminder(signupListID)
      .post()
      .then(({ manualRemindersSent }) => {
        dispatch({
          type: "Set Manual Reminders Sent",
          manualRemindersSent: manualRemindersSent?.length
            ? manualRemindersSent
            : [],
        });
        handleConfirmationCancel();
      })
      .catch((err) => {
        console.log(err);
        alert(
          "Oh no! There was a problem sending the reminders. Please contact help@flocknote.com for assistance."
        );
        handleConfirmationCancel();
      });
  };

  const handleButtonClick = (e) => {
    if (e) e.stopPropagation();
    setShowSendReminderConfirmation((prev) => !prev);
  };

  const handleConfirmationCancel = (e) => {
    if (e) e.stopPropagation();
    setLoading(false);
    setShowSendReminderConfirmation(false);
  };

  return (
    <Wrapper>
      <span ref={buttonRef}>
        <FnrHoverButton
          onClick={handleButtonClick}
          forceHover={showSendReminderConfirmation}
        >
          <ReminderButtonContent>
            <FnrIcon fad fa-mobile-alt />
            Send Signup reminders now
          </ReminderButtonContent>
        </FnrHoverButton>
      </span>

      <FnrPopover
        show={showSendReminderConfirmation}
        buttonRef={buttonRef}
        onShouldClose={handleConfirmationCancel}
      >
        <ConfirmationWrapper>
          <strong>Are you sure?</strong> This will send a reminder to everyone
          currently signed up.
          <ButtonRow>
            <FnrButton onClick={handleConfirmationCancel} size="small">
              Cancel
            </FnrButton>
            <FnrButton
              color="blue"
              onClick={sendManualReminders}
              loading={loading}
              size="small"
            >
              <ButtonText>Send Reminders</ButtonText>
              <ButtonIcon fas fa-mobile-alt />
            </FnrButton>
          </ButtonRow>
        </ConfirmationWrapper>
      </FnrPopover>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: inline-block;
`;

const ConfirmationWrapper = styled.div`
  font-size: 16px;
  padding: 8px;
  max-width: 260px;
  box-sizing: border-box;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
`;
